








import Vue from "vue";
import router from "@/router/";
export default Vue.extend({
    props:{
        icon:{
            type: String,
            default: ''
        },
        titre:{
            type: String,
            default: ''
        },
        href:{
          type: String,
          default: ''
        }
    },
    methods:{
    
}
}

);
